import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ProgressStepper from './components/ProgressStepper'
import Step1 from './components/steps/Step1.jsx'
import Step2 from './components/steps/Step2.jsx'
import Step3 from './components/steps/Step3.jsx'
import Step4 from './components/steps/Step4.jsx'
import Step4_5 from './components/steps/Step4_5.jsx'
import Step5 from './components/steps/Step5.jsx'
import { STORAGE_KEYS, QUIZ_OPTIONS_DATA, QUIZ_STEPS_PORN } from './constants'
import PornPage from './components/PornPage'
import { useQuizSelections } from './hooks/useLocalStorage'
import { preloadNextStepImages } from './utils/imagePreloader'
import { initTracking } from './utils/tracking'
import { useDesign } from './contexts/DesignContext'
import { useSteps } from './hooks/useSteps'

const STEPS_COMPONENTS = {
  welcome: PornPage,
  step1: Step1,
  step2: Step2,
  step3: Step3,
  step4: Step4,
  step4_5: Step4_5,
  step5: Step5,
}

const validateStepData = (step, answer) => {
  switch (step) {
    case 'welcome':
      return answer && answer.trim() !== ''
    case 'step1':
      return answer && answer.ethnicity && answer.age
    case 'step2':
      return answer && answer.bodyType && answer.breastSize && answer.buttSize
    case 'step3':
      return answer && answer.hairColor && answer.hairStyle && answer.eyeColor
    case 'step4':
      return answer && answer.voice && answer.voiceAudio && answer.personality
    case 'step4_5':
      return answer && answer.kink
    case 'step5':
      return answer && answer.trim() !== ''
    default:
      return true
  }
}

function Porn() {
  const [currentStep, setCurrentStep] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const location = useLocation()
  const { isNewDesign } = useDesign()
  const { getActiveSteps } = useSteps()

  const [selections, setSelections] = useQuizSelections(location.pathname)

  // Получаем список шагов в зависимости от дизайна и режима
  const activeSteps = useMemo(() => {
    return getActiveSteps(QUIZ_STEPS_PORN)
  }, [getActiveSteps])

  // Скрытые шаги - находим индексы loading, createAccount, login
  const hiddenSteps = useMemo(() => {
    const loadingIndex = activeSteps.indexOf('loading')
    const createAccountIndex = activeSteps.indexOf('createAccount')
    const loginIndex = activeSteps.indexOf('login')

    return [loadingIndex, createAccountIndex, loginIndex].filter(index => index !== -1)
  }, [activeSteps])

  const handleAnswer = useCallback(
    (step, answer) => {
      if (!validateStepData(step, answer)) {
        return
      }

      setIsTransitioning(true)

      // Save to localStorage for the new steps
      if (step === 'welcome' || step.startsWith('step')) {
        const existing = JSON.parse(localStorage.getItem(STORAGE_KEYS.AI_GIRLFRIEND_SELECTIONS_PORN) || '{}')
        const updated = { ...existing, [step]: answer }
        localStorage.setItem(STORAGE_KEYS.AI_GIRLFRIEND_SELECTIONS_PORN, JSON.stringify(updated))
      }

      setSelections(prev => ({
        ...prev,
        [step]: answer,
      }))

      // Preload images for the next step
      setTimeout(() => {
        preloadNextStepImages(step, QUIZ_OPTIONS_DATA)
      }, 100)

      setTimeout(() => {
        setCurrentStep(prev => prev + 1)
      }, 500)
    },
    [setSelections],
  )

  const handlePrevious = useCallback(() => {
    if (isTransitioning) return

    setIsTransitioning(true)
    setCurrentStep(prev => (prev > 0 ? prev - 1 : 0))
  }, [isTransitioning])

  const resetQuiz = useCallback(() => {
    setCurrentStep(0)
    setSelections({})
    setIsTransitioning(false)
    localStorage.removeItem(STORAGE_KEYS.AI_GIRLFRIEND_SELECTIONS_PORN)
  }, [setSelections])

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false)
    }, 100)

    return () => clearTimeout(timer)
  }, [currentStep])

  // Initialize tracking system when app starts
  useEffect(() => {
    initTracking()
  }, [])

  const getVisibleSteps = useCallback(() => {
    return activeSteps.filter((_, index) => !hiddenSteps.includes(index))
  }, [activeSteps, hiddenSteps])

  const shouldShowProgressStepper = useCallback(() => {
    return !hiddenSteps.includes(currentStep)
  }, [currentStep, hiddenSteps])

  const currentStepName = activeSteps[currentStep]
  const CurrentStepComponent = STEPS_COMPONENTS[currentStepName]

  if (!CurrentStepComponent) {
    return (
      <div className='quizContentWrapper'>
        <div className='quizContent'>
          <h1>Step not found</h1>
          <p>Current step: {currentStep}</p>
          <p>Step name: {currentStepName}</p>
          <p>Is new design: {isNewDesign ? 'Yes' : 'No'}</p>
          <p>Active steps: {activeSteps.join(', ')}</p>
          <button onClick={resetQuiz}>Reset Quiz</button>
        </div>
      </div>
    )
  }

  return (
    <div className={`app ${isTransitioning ? 'no-click' : ''}`}>
      {shouldShowProgressStepper() && <ProgressStepper currentStep={currentStep} totalSteps={getVisibleSteps().length} />}
      <CurrentStepComponent onAnswer={handleAnswer} selections={selections} onPrevious={handlePrevious} isTransitioning={isTransitioning} />
    </div>
  )
}

export default Porn
